"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playPieceInHole = exports.playPieceContactsBoundary = exports.playPieceContactsPole = exports.playPieceContactsPiece = exports.playLoaded = exports.load = exports.getMusicPath = void 0;
var log_sidecar_1 = require("@engine/log-sidecar");
var soundsGeneric_sidecar_1 = require("@engine/soundsGeneric-sidecar");
var _audioSprite2_sidecar_1 = require("proto/goat/sound/_audioSprite2-sidecar");
var doPlayLoaded = false;
var soundTest = false;
var _musicPath = '';
function getMusicPath() {
    return _musicPath;
}
exports.getMusicPath = getMusicPath;
var logNamespace = 'sounds';
function load(audioJson, musicPath) {
    _musicPath = musicPath + '/';
    soundsGeneric_sidecar_1.soundsGeneric.load(audioJson, function () {
        log_sidecar_1.log.x(logNamespace, 'loaded');
        if (doPlayLoaded) {
            playLoaded();
        }
        if (soundTest) {
            setInterval(function () {
                playLoaded();
            }, 500);
        }
    });
    // playMusicMenu()
}
exports.load = load;
function playLoaded() {
    playPieceInHole();
}
exports.playLoaded = playLoaded;
function playPieceContactsPiece() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood1]);
}
exports.playPieceContactsPiece = playPieceContactsPiece;
function playPieceContactsPole() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood1]);
}
exports.playPieceContactsPole = playPieceContactsPole;
function playPieceContactsBoundary() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood1]);
}
exports.playPieceContactsBoundary = playPieceContactsBoundary;
function playPieceInHole() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood2]);
    // soundsGeneric.playRandom([
    //   _audioSprite2.Button_01,
    //   _audioSprite2.Button_01_Variation_01,
    //   _audioSprite2.Button_01_Variation_02,
    //   _audioSprite2.Button_01_Variation_03,
    // ])
}
exports.playPieceInHole = playPieceInHole;
